import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { App_Tooltip } from 'src/app/utils/interfaces';
import { CPopoverTooltipComponent } from '../c-popover/c-popover-tooltip/c-popover-tooltip.component';

@Component({
  selector: 'app-c-tooltip-button',
  templateUrl: './c-tooltip-button.component.html',
  styleUrls: ['./c-tooltip-button.component.scss'],
})
export class CTooltipButtonComponent {
  @Input({ required: true }) tooltip!: App_Tooltip | undefined;

  constructor(
    private popoverController: PopoverController
  ) { }

  onOpenPopoverTooltipClick($event: any) {
    if (this.tooltip) {
      this.popoverController.create({
        component: CPopoverTooltipComponent,
        componentProps: {
          tooltip: this.tooltip,
        },
        event: {...$event, target: $event.currentTarget},
        side: 'bottom',
        alignment: 'center',
      }).then(popover => popover.present());
    }
  }

}
